{
  let startOverrideIntervalId;
  let bzBtnLoaderIntervalId;
  let iframeListenerIntervalId;
  let ghostMode = null;
  let checkoutSelector = null;
  let buyNowSelector = null;
  let iframeSelector = null;
  async function getCart() {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data && data["items"] !== null) {
        return data.items.length;
      }
    } catch (e) {
      customLogger("Get cart failed: " + e);
    }
    return null;
  }
  function openCheckout(retries, callback, event) {
    try {
      const interval = setInterval(async function () {
        retries = retries - 1;
        const items = await getCart();
        if (items !== null && items > 0) {
          callback();
          clearInterval(interval);
          closePopups();
        }
        if (retries == 0) {
          clearInterval(interval);
          handleButtonOverrideFailure(event);
        }
      }, 1000);
    } catch (e) {
      customLogger("Checkout opening failed: " + e);
      handleButtonOverrideFailure(event);
    }
  }
  function expireCartCookie() {
    try {
      const date = new Date();
      date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toString();
      document.cookie = "cart" + "=" + expires + "; path=/";
    } catch (e) {
      customLogger("Failed to clear the cookie: " + e);
    }
  }
  function addSampleBreezeTag() {
    try {
      const newDiv = document.createElement("breeze-button");
      newDiv.style.display = "none";
      document.body.appendChild(newDiv);
    } catch (e) {
      customLogger("Error in addSampleBreezeTag: " + e);
    }
  }
  function startOverride() {
    try {
      const bzGhostMode = window.bzGhostMode ?? null;
      if (bzGhostMode !== null) {
        startOverrideIntervalId.clear();
        if (bzGhostMode === true && ghostMode !== "samurai") {
          return;
        }
        bzBtnLoaderIntervalId = setIntervalExponential(
          addBreezeCheckout,
          5,
          2,
          10000
        );
      }
    } catch (e) {
      customLogger("Error in startOverride: " + e);
    }
  }
  function getAddToCartButton(containerElement = null) {
    const selectorArr = [
      "button[class*='product-form__submit']",
      "button[class*='add-to-cart']",
    ];
    if (
      typeof window.addToCartSelector === "string" &&
      window.addToCartSelector !== ""
    ) {
      selectorArr.push(window.addToCartSelector);
    }
    const selector = selectorArr.join(",");
    return getNativeButtons(selector, containerElement);
  }
  function addBreezeCheckout() {
    try {
      addSampleBreezeTag();
      const isBreezeAvailable =
        window.breeze !== undefined && window.breeze !== null;
      if (!isBreezeAvailable) {
        customLogger("Breeze is not available.");
        return;
      }
      customLogger("Breeze is available");
      bzBtnLoaderIntervalId.clear();
      createButtonSelectors();
      if (iframeSelector !== null) {
        iframeListenerIntervalId = setIntervalExponential(
          addIFrameListener,
          5,
          2,
          10000
        );
      }
      document.addEventListener("click", documentClickListener, true);
      if (window.bzInternationalConfig?.enable === true) {
        removeBreezeIfUnsupportedCountry();
      }
    } catch (e) {
      customLogger("Error in addBreezeCheckout: " + e);
      handleButtonOverrideFailure();
    }
  }
  async function documentClickListener(e) {
    const target = e.target;
    const composedPath = e.composedPath();
    const isInsideShadowRoot = composedPath.some(
      (element) => element.shadowRoot
    );
    const handleButtonClick = async (button, handler) => {
      if (button) {
        addButtonLoader(button);
        await handler(e);
        removeButtonLoader(button);
      }
    };
    if (isInsideShadowRoot) {
      for (const element of composedPath) {
        if (!(element instanceof Element)) continue;
        const isCheckout =
          checkoutSelector && element.matches(checkoutSelector);
        const isBuyNow = buyNowSelector && element.matches(buyNowSelector);
        if (isCheckout || isBuyNow) {
          await handleButtonClick(
            element,
            isCheckout ? handleCheckoutEvent : handleBuyNowEvent
          );
          break;
        }
      }
    } else {
      const checkoutButton = checkoutSelector
        ? target.closest(checkoutSelector)
        : null;
      const buyNowButton = buyNowSelector
        ? target.closest(buyNowSelector)
        : null;
      if (checkoutButton)
        await handleButtonClick(checkoutButton, handleCheckoutEvent);
      if (buyNowButton)
        await handleButtonClick(buyNowButton, handleBuyNowEvent);
    }
  }
  function addIFrameListener() {
    if (iframeSelector !== null) {
      const iframe = document.getElementById(iframeSelector);
      if (!iframe) return;
      const iframeDoc =
        iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDoc) return;
      iframeListenerIntervalId.clear();
      iframeDoc.addEventListener("click", documentClickListener, true);
    }
  }
  async function handleCheckoutEvent(event) {
    try {
      event.preventDefault();
      if (typeof window.bzLogButtonClick === "function") {
        window.bzLogButtonClick();
      }
      event.stopImmediatePropagation();
      const breeze = window.breeze;
      if (breeze && typeof breeze.startCheckout === "function") {
        if (window.bzEmbraceNotesUpdate === true) {
          await updateNotesAttributeToCart();
        }
        breeze.startCheckout();
      } else {
        customLogger("Breeze checkout function is not available");
        handleButtonOverrideFailure(event);
      }
    } catch (e) {
      customLogger("Error in handleCheckoutEvent: " + e);
      handleButtonOverrideFailure(event);
    }
  }
  async function handleBuyNowEvent(event) {
    try {
      event.preventDefault();
      if (typeof window.bzLogButtonClick === "function") {
        window.bzLogButtonClick();
      }
      event.stopImmediatePropagation();
      const startCheckout = window.breeze?.startCheckout;
      if (startCheckout && typeof startCheckout === "function") {
        expireCartCookie();
        await fetch("/cart/clear.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: "{}",
        });
        await addProductToCartAndCheckout(event, startCheckout);
      } else {
        customLogger("Breeze checkout function is not available");
        handleButtonOverrideFailure(event);
      }
    } catch (e) {
      customLogger(`Error in handleBuyNowEvent: ${e}`);
      handleButtonOverrideFailure(event);
    }
  }
  async function addProductToCartAndCheckout(event, startCheckout) {
    let isProductAddedToCart = false;
    const target = event.target;
    // if (target instanceof HTMLElement) {
    //   const productForm = target.closest(
    //     "form[method='post'][action*='/cart/add']"
    //   )
    //   if (productForm instanceof HTMLFormElement) {
    //     const formData = new FormData(productForm)
    //     try {
    //       const response = await fetch("/cart/add.js", {
    //         method: "POST",
    //         body: formData
    //       })
    //       if (response.status === 200) {
    //         startCheckout()
    //         isProductAddedToCart = true
    //         const data = await response.json()
    //         customLogger(
    //           `Product added to cart successfully: ${JSON.stringify(data)}`
    //         )
    //       }
    //     } catch (error) {
    //       customLogger(`Error while adding product to cart: ${error}`)
    //     }
    //   }
    // }
    if (!isProductAddedToCart) {
      const retry = window.checkoutOpenRetry || 10;
      const addToCartButton = getAddToCartButton();
      clickAddToCartBtn(event, addToCartButton);
      openCheckout(retry, startCheckout, event);
    }
  }
  function clickAddToCartBtn(event, addToCartButtons) {
    if (addToCartButtons.length === 0) {
      customLogger("Error: No add to cart button found");
      handleButtonOverrideFailure(event);
    } else if (addToCartButtons.length === 1) {
      addToCartButtons[0].click();
    } else {
      // getting addToCart button nearest to buy now button
      let attemptCount = 0;
      const maxAttempts = 50;
      let currentElement = event.target;
      while (currentElement && attemptCount < maxAttempts) {
        const buttons = getAddToCartButton(currentElement);
        if (buttons.length !== 0) {
          buttons[0].click();
          return;
        }
        currentElement = currentElement.parentElement;
        attemptCount++;
      }
      customLogger("Error: unable to find nearest add to cart button");
      handleButtonOverrideFailure(event);
    }
  }
  function closePopups() {
    try {
      if (
        typeof window.bzPopupCloseSelector === "string" &&
        window.bzPopupCloseSelector !== ""
      ) {
        const miniCartCloseBtn = getNativeButtons(window.bzPopupCloseSelector);
        miniCartCloseBtn.forEach((btn) => btn.click());
      }
    } catch (error) {
      customLogger(`Error: unable to close mini cart popup: ${error}`);
    }
  }
  async function updateNotesAttributeToCart() {
    let notesValue = null;
    try {
      const noteElements = document.querySelectorAll("textarea[name*=note]");
      const noteElement = noteElements[noteElements.length - 1];
      if (noteElement instanceof HTMLTextAreaElement) {
        notesValue = noteElement.value.trim();
      }
      if (notesValue !== null) {
        const response = await fetch(`/cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: notesValue }),
        });
        if (response.status !== 200) {
          throw new Error("Unable to update notes, api response failure");
        }
      } else {
        throw new Error("Unable to get notes from page");
      }
    } catch (error) {
      customLogger(`Error|updateNotesAttributeToCart|${error}`);
    }
  }
  function addButtonLoader(button) {
    button.style.opacity = "0.5";
    if (
      button instanceof HTMLInputElement ||
      button instanceof HTMLButtonElement
    ) {
      button.disabled = true;
    } else {
      button.style.pointerEvents = "none";
      button.style.cursor = "not-allowed";
    }
  }
  function removeButtonLoader(button) {
    button.style.opacity = "";
    if (
      button instanceof HTMLInputElement ||
      button instanceof HTMLButtonElement
    ) {
      button.disabled = false;
    } else {
      button.style.pointerEvents = "";
      button.style.cursor = "";
    }
  }
  function createButtonSelectors() {
    checkoutSelector =
      typeof window.checkoutSelector === "string" &&
      window.checkoutSelector !== ""
        ? window.checkoutSelector
        : "button[name='checkout'],a[href='/checkout']";
    buyNowSelector =
      typeof window.buyNowSelector === "string" && window.buyNowSelector !== ""
        ? window.buyNowSelector
        : "div.shopify-payment-button";
    iframeSelector =
      typeof window.iframeSelector === "string" && window.iframeSelector !== ""
        ? window.iframeSelector
        : null;
  }
  // utils
  function getNativeButtons(selector, containerElement = null) {
    let buttons = [];
    try {
      if (selector !== "") {
        if (containerElement !== null) {
          buttons = Array.from(containerElement.querySelectorAll(selector));
        } else {
          buttons = Array.from(document.querySelectorAll(selector));
        }
      }
    } catch (e) {
      customLogger(`Error in getNativeButtons: ${e}`);
    }
    return buttons;
  }
  function customLogger(message) {
    if (ghostMode === "samurai") {
      console.log(`BZ|${message}`);
    }
  }
  // script start point
  try {
    customLogger("FunctionCalled with setIntervalExponential | startOverride");
    ghostMode = window.localStorage.getItem("ghost");
    startOverrideIntervalId = setIntervalExponential(startOverride, 5, 2);
  } catch (e) {
    customLogger("Error starting the override process: " + e);
    handleButtonOverrideFailure();
  }
  // IP based routing
  async function removeBreezeIfUnsupportedCountry() {
    if (typeof window.bzInternationalConfig !== "undefined") {
      const supportedCountryCode = Array.isArray(
        window.bzInternationalConfig.supportedCountryCode
      )
        ? window.bzInternationalConfig.supportedCountryCode
        : [];
      supportedCountryCode.push("IN"); // by default India is supported
      try {
        const response = await fetch("https://ipinfo.io/json");
        const result = await response.json();
        if (
          typeof result === "object" &&
          !Array.isArray(result) &&
          result.country &&
          !supportedCountryCode.includes(result.country)
        ) {
          removeButtonOverriding();
        }
      } catch (error) {
        customLogger(`Error fetching IP location: ${error}`);
      }
    }
  }
  function setIntervalExponential(callback, initialDelay, factor, maxDelay) {
    let currentDelay = initialDelay;
    let timeoutId = null;
    let isCleared = false;
    function executeCallback() {
      if (isCleared === false) {
        callback();
        currentDelay *= factor;
        if (currentDelay <= 0) {
          currentDelay = 1;
        }
        if (maxDelay !== undefined && currentDelay > maxDelay) {
          currentDelay = maxDelay;
        }
        timeoutId = setTimeout(executeCallback, currentDelay);
      }
    }
    timeoutId = setTimeout(executeCallback, currentDelay);
    return {
      clear: () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
          isCleared = true;
        }
      },
    };
  }
  function handleButtonOverrideFailure(event = null) {
    try {
      customLogger("FunctionCalled | handleButtonOverrideFailure");
      removeButtonOverriding();
      if (event !== null && event.target !== null) {
        const targetElement = event.target;
        if (typeof targetElement.click === "function") {
          targetElement.click();
        }
      }
    } catch (error) {
      customLogger(`Error in handleButtonOverrideFailure: ${error}`);
    }
  }
  function removeButtonOverriding() {
    document.removeEventListener("click", documentClickListener, true);
  }
}
